<nav style="z-index: 111;" id="navigation">
    <!-- container -->
    <div class="container">
        <div class="col-md-9">
            <!-- responsive-nav -->
            <div id="responsive-nav">
                <!-- NAV -->

                <!-- <li class="nav-item"><a routerLink="/" class="catagories home" (click)="selectedCategory($event)">Home</a></li>
                    <li class="nav-item"><a [routerLink]="['/liquor']" class="catagories liquor"
                            (click)="selectedCategory($event)">Liquor</a></li>
                    <li class="nav-item"><a [routerLink]="['/sweets']" class="catagories sweets"
                            (click)="selectedCategory($event)">Sweets</a></li>
                    <li class="nav-item"><a [routerLink]="['/chocolates']" class="catagories chocolates"
                            (click)="selectedCategory($event)">Chocolates</a></li>
                    <li class="nav-item"><a [routerLink]="['/chips']" class="catagories chips"
                            (click)="selectedCategory($event)">Chips</a></li>
                    <li class="nav-item"><a [routerLink]="['/beverages']" class="catagories beverages"
                            (click)="selectedCategory($event)">Beverages</a></li>
                    <li class="nav-item"><a [routerLink]="['/biscuits']" class="catagories biscuits"
                            (click)="selectedCategory($event)">Biscuits</a></li>
                    <li class="nav-item"><a [routerLink]="['/hygiene']" class="catagories hygiene"
                            (click)="selectedCategory($event)">Hygiene</a></li>
                    <li class="nav-item">
                        <a class="catagories selected-category" (click)="clearSearch(); selectedCategory($event)" [routerLink]="['/promotions']">PROMOTIONS</a>
                    </li> -->
                <ul class="main-nav nav navbar-nav mr-auto">
                    <li class="nav-item" *ngFor="let nav of navLinks"><a class="mainmenulink"
                            [routerLink]="['/products']" [queryParams]="{pageNumber: 1, category: nav.name}"
                            [class]="nav.linkedClass" (click)="selectedCategory($event)">{{nav.name}}</a></li>
                </ul>

                <!-- /NAV -->
            </div>
        </div>

        <!-- SEARCH BAR -->
        <div class="col-md-3">
            <div class="searchBar">
                <input id="searchQueryInput" type="text" name="searchQueryInput" placeholder="Search for products"
                    [(ngModel)]="searchText" [ngModelOptions]="{ standalone: true }" (keyup.enter)="search()" />
                <button id="searchQuerySubmit" (click)="search()" name="searchQuerySubmit">
                    <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                        <path fill="#666666"
                            d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z">
                        </path>
                    </svg>
                </button>
            </div>
            <!-- /SEARCH BAR -->
        </div>
        <!-- /responsive-nav -->
    </div>
    <!-- /container -->
</nav>
